module.exports = __webpack_public_path__ + "static/img/shfjgszzzyhzs_2.94d40d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shfjgszzzyhzs_2.jpg
// module id = VORd
// module chunks = 15